import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userData = authService.getUser();
  // console.log(userData.token);

  if (!userData.token){
    router.navigate(["auth/login"]);
    return false
  }

   return authService.tokenValidation(userData.token)
   .then((response) => {
      if(response.status) {
          return true;
      } else {
          authService.deleteUser();
          router.navigate(["auth/login"]);
          return false;
      }
   })
};
